import { extendObservable } from 'mobx';

class HomeModel {
    constructor(session) {
        this._session = session;
        extendObservable(this, {
            streamstatus: '',
            streamservertype: '',
            streamdestination: ''
        });
    }

    async load() {
        console.log('HomeModel: loading...');

        try {
            const settings = await this._session.rpc('call', [
                '',
                'instreamer4',
                'status',
                {}
            ]);

            const jsonSession = await this._session.getJsonStream();
            let servertypeselectSetting = '',
                streamurlSetting = '';

            if (jsonSession.length > 0) {
                const jsonDestinations = jsonSession[0][2];
                const remoteurlsplit = jsonDestinations.remote_url.split('://');
                const remoteurlSetting = remoteurlsplit[1];

                if (remoteurlSetting === '127.0.0.1') {
                    servertypeselectSetting = 'Icecast Server';
                } else if (remoteurlSetting === '') {
                    servertypeselectSetting = '';
                } else {
                    servertypeselectSetting = 'Icecast Source';
                }

                if (remoteurlSetting === '127.0.0.1') {
                    const settingsnetwork = await this._session.rpc('call', [
                        '',
                        'network',
                        'status',
                        {}
                    ]);
                    streamurlSetting =
                        'http://' +
                        settingsnetwork[1]['ipv4-address'][0] +
                        ':' +
                        jsonDestinations.port +
                        '/' +
                        jsonDestinations.mount_point;
                } else {
                    streamurlSetting =
                        'http://' +
                        remoteurlSetting +
                        ':' +
                        jsonDestinations.port +
                        '/' +
                        jsonDestinations.mount_point;
                }
            }
            const settingobj = {
                streamstatus: settings[1].streaming,
                streamservertype: servertypeselectSetting,
                streamdestination: streamurlSetting
            };

            Object.assign(this, settingobj);
        } catch (err) {
            console.error('HomeModel:' + err);
        }
        console.log('HomeModel: loaded...');
    }
}

export default HomeModel;



// WEBPACK FOOTER //
// ./src/models/HomeModel.js